import * as locacionsAssignment from './locationsAssignment';
import * as locationsUsage from './locationsUsage';
import * as locations from './locations';
import * as warehouse from './warehouse';
import * as allocations from './allocations';

const reducers = {
  ...warehouse,
  ...allocations,
  ...locations,
  ...locacionsAssignment,
  ...locationsUsage,
};

export default reducers;
